import { render, staticRenderFns } from "./BaseInfo1.vue?vue&type=template&id=2fe6b747&scoped=true&"
import script from "./BaseInfo1.vue?vue&type=script&lang=js&"
export * from "./BaseInfo1.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfo1.vue?vue&type=style&index=0&id=2fe6b747&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6b747",
  null
  
)

export default component.exports